import { useNavigate } from "react-router-dom";

const Header = ({ highlightRegister }) => {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        /* ── Top Info Bar ── */
        .header-top-info-bar {
          width: 100%;
          background: #EFF1F1;
          padding: 5px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          font-family: Arial, sans-serif;
        }

        .header-top-info-marquee-wrapper { display: none; }
        .header-top-info-mobile { display: none; }

        @keyframes header-info-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .header-top-info-marquee-track {
          display: inline-flex;
          white-space: nowrap;
          animation: header-info-scroll 20s linear infinite;
          font-size: 11px;
          color: rgba(32, 32, 32, 0.82);
        }

        @media (max-width: 991px) {
          .header-top-info-bar {
            position: relative;
            top: auto;
            left: auto;
            z-index: auto;
            padding: 4px 12px;
            gap: 0;
            flex-direction: column;
            align-items: center;
          }
          .header-top-info-desktop { display: none !important; }
          .header-top-info-marquee-wrapper {
            display: none !important;
          }
          .header-top-info-mobile {
            display: flex !important;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 4px 12px 2px;
            gap: 1px;
            font-size: 13px;
            color: rgba(32, 32, 32, 0.86);
            position: relative;
            top: auto;
            left: auto;
          }
          .header-top-info-mobile p {
            margin: 0;
            line-height: 1.2;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .main-navbar-mobile {
            margin-top: 0;
          }
        }

        .navbar-brand img {
          max-width: 120px;
          height: auto;
        }

        .navbar {
          padding: 10px 12px !important;
        }

        /* Contact Info Styles */
        .contact-info {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          color: #333;
          margin-right: 15px;
          padding-right: 15px;
          border-right: 1px solid #ddd;
        }

        .contact-info a {
          color: #333;
          text-decoration: none;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .contact-info a:hover {
          color: #007bff;
        }

        .contact-info .whatsapp-link {
          color: #333;
          text-decoration: none;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .contact-info .whatsapp-link:hover {
          color: #25D366;
        }

        .contact-info .phone-desktop {
          display: flex;
          align-items: center;
          gap: 5px;
          color: #555;
          font-weight: 500;
          cursor: default;
        }

        .contact-info .divider {
          color: #ccc;
          margin: 0 4px;
        }

        .contact-info .working-hours {
          font-size: 11px;
          color: #666;
        }

        .annual-plan-pill {
          font-size: 12px;
          color: #0b3a83;
          background: linear-gradient(135deg, #e8f0fe, #f0f4fa);
          border: 1px solid #c8d6ea;
          border-radius: 20px;
          padding: 5px 14px;
          font-weight: 500;
          white-space: nowrap;
          margin-right: 12px;
        }

        .annual-plan-pill strong {
          color: #0f9b47;
          font-weight: 700;
        }

        /* Desktop Navigation */
        @media (min-width: 1440px) {
          .mobile-nav-buttons {
            display: none !important;
          }
        }

        /* --- MOBILE NAVIGATION (Below 992px) --- */
        @media (max-width: 991px) {
          .desktop-nav {
            display: none !important;
          }

          .mobile-nav-buttons {
            display: flex !important;
            gap: 5px !important;
            align-items: center !important;
            flex-shrink: 0 !important;
          }

          .mobile-nav-buttons a {
            font-size: 11px !important;
            padding: 4px 8px !important;
            white-space: nowrap !important;
            border-radius: 4px !important;
            font-weight: 500 !important;
            min-height: 28px !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
          }

          .mobile-nav-buttons .login-btn {
            background: transparent !important;
            color: #007bff !important;
            border: 1px solid #007bff !important;
          }

          .mobile-nav-buttons .login-btn:hover {
            background: #007bff !important;
            color: white !important;
          }

          .mobile-nav-buttons .register-btn {
            background: #007bff !important;
            color: white !important;
            border: 1px solid #007bff !important;
          }

          .mobile-nav-buttons .register-btn:hover {
            background: #0056b3 !important;
            border-color: #0056b3 !important;
          }

          .container-fluid {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            flex-wrap: nowrap !important;
            padding: 0 6px !important;
          }

          .navbar-brand {
            padding: 2px 4px !important;
            margin: 0 !important;
            display: flex !important;
            align-items: center !important;
            line-height: 0 !important;
          }

          .navbar-brand img {
            max-width: 95px !important;
            height: auto !important;
            display: block !important;
          }

          /* Mobile Contact Info — sits BELOW the thin info strip */
          .mobile-contact-info {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            width: 100% !important;
            background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
            padding: 3px 4px !important;
            justify-content: center !important;
            align-items: center !important;
            gap: 6px !important;
            position: relative !important;
            top: auto !important;
            left: auto !important;
            z-index: 1001 !important;
            overflow-x: auto !important;
          }

          .mobile-contact-numbers {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 6px !important;
            width: auto !important;
            flex-shrink: 0 !important;
            line-height: 1 !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          .mobile-contact-info a {
            color: #ffffff !important;
            text-decoration: none !important;
            font-weight: 600 !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 2px !important;
            font-size: 9px !important;
            line-height: 1 !important;
            margin: 0 !important;
            padding: 0 !important;
            white-space: nowrap !important;
          }

          .mobile-contact-info a svg {
            width: 8px !important;
            height: 8px !important;
          }

          .mobile-contact-info .working-hours {
            font-size: 9px !important;
            font-weight: 600 !important;
            color: rgba(255,255,255,0.95) !important;
            border-left: 1px solid rgba(255,255,255,0.4) !important;
            padding-left: 6px !important;
            text-align: center !important;
            line-height: 1 !important;
            margin: 0 !important;
            white-space: nowrap !important;
            flex-shrink: 0 !important;
          }
        }

        /* Hide mobile contact on desktop */
        @media (min-width: 992px) {
          .mobile-contact-info {
            display: none !important;
          }
          
          .main-navbar-mobile {
            margin-top: 0;
          }
        }

        /* --- MEDIUM MOBILE (390px - 490px) Perfect Range --- */
        @media (min-width: 390px) and (max-width: 490px) {
          .navbar-brand img {
            max-width: 95px !important;
          }

          .mobile-nav-buttons {
            gap: 5px !important;
          }

          .mobile-nav-buttons a {
            font-size: 10.5px !important;
            padding: 3px 7px !important;
            min-height: 28px !important;
          }

          .container-fluid {
            padding: 0 6px !important;
          }

          .navbar {
            padding: 4px 6px !important;
          }

          .mobile-contact-info {
            padding: 0 0 2px !important;
          }

          .mobile-contact-numbers {
            gap: 10px !important;
          }

          .mobile-contact-info a {
            font-size: 11px !important;
          }

          .mobile-contact-info .working-hours {
            font-size: 12.5px !important;
          }
        }

        /* --- SMALL MOBILE (361px - 389px) --- */
        @media (min-width: 361px) and (max-width: 389px) {
          .navbar-brand img {
            max-width: 90px !important;
          }

          .mobile-nav-buttons {
            gap: 4px !important;
          }

          .mobile-nav-buttons a {
            font-size: 10px !important;
            padding: 3px 6px !important;
            min-height: 26px !important;
          }

          .container-fluid {
            padding: 0 5px !important;
          }

          .navbar {
            padding: 3px 5px !important;
          }

          .mobile-contact-info {
            padding: 0 0 2px !important;
          }

          .mobile-contact-numbers {
            gap: 8px !important;
          }

          .mobile-contact-info a {
            font-size: 10.5px !important;
          }

          .mobile-contact-info .working-hours {
            font-size: 12px !important;
          }
        }

        /* --- VERY SMALL MOBILE (320px - 360px) --- */
        @media (max-width: 360px) {
          .navbar-brand img {
            max-width: 82px !important;
          }

          .mobile-nav-buttons {
            gap: 3px !important;
          }

          .mobile-nav-buttons a {
            font-size: 9.5px !important;
            padding: 2px 5px !important;
            min-height: 24px !important;
          }

          .container-fluid {
            padding: 0 4px !important;
          }

          .navbar {
            padding: 3px 4px !important;
          }

          .navbar-brand {
            padding: 1px 3px !important;
          }

          .mobile-contact-info {
            padding: 0 0 2px !important;
          }

          .mobile-contact-numbers {
            gap: 6px !important;
          }

          .mobile-contact-info a {
            font-size: 10px !important;
          }

          .mobile-contact-info .working-hours {
            font-size: 11.5px !important;
          }
        }
      `}</style>

      {/* Top Info Bar */}
      <div className="header-top-info-bar">
        {/* Desktop: static */}
        <span className="header-top-info-desktop" style={{ fontSize: "16px", color:"rgba(32, 32, 32, 0.86)", fontFamily: "Arial, sans-serif" }}>
           DocMaster's Head Quarters @ The Electronic City, A 75 Sector 63 Noida
        </span>
        <span className="header-top-info-desktop" style={{ color: "rgba(0,0,0,0.2)" }}>|</span>
        <span className="header-top-info-desktop" style={{ fontSize: "16px", color:"rgba(32, 32, 32, 0.86)", fontFamily: "Arial, sans-serif" }}>
           Associate of Shri Subhash Parasram Electronic Park Private Limited
        </span>
        {/* Mobile: static two-line address */}
        <div className="header-top-info-mobile">
          <p>DocMaster Head Office - A 75 Sector 63 Noida</p>
          <p> Division of Shri Subhash Parasram Electronic Park Pvt Ltd</p>
        </div>
      </div>

      {/* Mobile Top Contact Bar - Only visible on mobile */}
      <div className="mobile-contact-info">
        <div className="mobile-contact-numbers">
          <a href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services.">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="#ffffff"
              viewBox="0 0 24 24"
            >
              <path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" />
            </svg>
            9289 44 00 49
          </a>
          <a href="tel:+919289440049">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="#ffffff"
              viewBox="0 0 24 24"
            >
              <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
            </svg>
            9289 44 00 49
          </a>
        </div>
        <span className="working-hours">Mon-sat (10:00 AM to 5:00 PM)</span>
      </div>

      <nav
        className="navbar navbar-light w-100 px-3 main-navbar-mobile"
        style={{ position: "relative" }}
      >
        <div className="container-fluid px-0" style={{ display: "flex", alignItems: "center" }}>
          <a href="/" className="navbar-brand p-1 px-2 rounded">
            <img
              src="images/docmasterLogo.png"
              alt="Logo"
              className="logo img-fluid"
            />
          </a>

          <div className="desktop-nav" style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}>
            <a
              href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
              style={{ display: "flex", alignItems: "center", gap: "6px", color: "#25D366", fontWeight: "600", fontSize: "16px", textDecoration: "none" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#25D366" viewBox="0 0 24 24"><path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" /></svg>
              9289 44 00 49
            </a>
            <span style={{ color: "#ccc" }}>|</span>
            <a href="tel:+919289440049" style={{ display: "flex", alignItems: "center", gap: "6px", color: "#555", fontWeight: "600", fontSize: "16px", textDecoration: "none" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#555" viewBox="0 0 24 24"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" /></svg>
              9289 44 00 49
            </a>
          </div>

          {/* Desktop Navigation - Login, Register */}
          <div className="desktop-nav d-flex align-items-center">
            {/* Contact Info beside Login */}
            <div className="contact-info" style={{ display: "none" }}>
              {/* WhatsApp - icon + number, both clickable */}
              {/* <a
                href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
                className="whatsapp-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#25D366"
                  viewBox="0 0 24 24"
                >
                  <path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" />
                </svg>
                9289 44 00 49
              </a>
              <span className="divider">|</span> */}
              {/* Phone - icon + number, not clickable on desktop */}
              {/* <span className="phone-desktop">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  fill="#555"
                  viewBox="0 0 24 24"
                >
                  <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
                </svg>
                9289 44 00 49
              </span>
              <span className="divider">|</span>
              <span className="working-hours">Mon-Sat (9:00am-6:00pm)</span> */}
            </div>

            {/* Annual plan pill */}
            {/* <div className="annual-plan-pill">
              Annual Plan Starts from&nbsp;<strong>₹250/year</strong>
            </div> */}

            <span
              className="py-1 text-decoration-none text-dark"
              style={{
                cursor: "pointer",
                fontSize: "14px",
                marginRight: "12px",
              }}
              onClick={() => navigate("/login")}
            >
              Login
            </span>

            <button
              className={`btn m-0 btn-sm bg-primary text-white px-3 ${highlightRegister ? "card-highlighted" : ""}`}
              style={{ fontSize: "13px" }}
              onClick={() =>
                navigate("/registration", {
                  state: { register_type: "register_button" },
                })
              }
            >
              Register For Free
            </button>
          </div>

          {/* Mobile Navigation Buttons */}
          <div className="mobile-nav-buttons d-lg-none">
            <a href="/login" className="btn btn-sm login-btn">
              Login
            </a>
            <a
              href="/registration"
              className={`btn btn-sm register-btn ${highlightRegister ? "card-highlighted" : ""}`}
            >
              Register For Free
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
